import { render, staticRenderFns } from "./double_recording_list.vue?vue&type=template&id=f15c6026&scoped=true&"
import script from "./double_recording_list.vue?vue&type=script&lang=js&"
export * from "./double_recording_list.vue?vue&type=script&lang=js&"
import style0 from "./double_recording_list.vue?vue&type=style&index=0&id=f15c6026&prod&lang=scss&scoped=true&"
import style1 from "./double_recording_list.vue?vue&type=style&index=1&id=f15c6026&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c6026",
  null
  
)

export default component.exports